import { render, staticRenderFns } from "./_gallery.vue?vue&type=template&id=bc3ded9a&scoped=true&"
import script from "./_gallery.vue?vue&type=script&lang=js&"
export * from "./_gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3ded9a",
  null
  
)

export default component.exports